import React from "react";

const FarmerTag = ({
  farmer,
  showMoreTags,
  visitTags,
  setSelectedTag,
  selectedTag,
  visibleTags,
  isDownloading,
  setShowMoreTags,
  handleDownloadTag,
}) => {
  return (
    <>
      {" "}
      <div className="fp-visit-photos">
        <div className="fp-photos-heading">
          <h3>Photos ({farmer?.photosCollected})</h3>
        </div>

        <div className="visit-tags-list">
          {(showMoreTags ? visitTags : visitTags.slice(0, 4)).map((tag) => (
            <button
              key={tag.id}
              className={`visit-tag-btn ${
                selectedTag === tag.id ? "active" : ""
              }`}
              onClick={() => {
                setSelectedTag(tag.id);
              }}
            >
              {tag.name}
            </button>
          ))}

          {!showMoreTags && visitTags.length > 4 && (
            <button
              className="visit-tag-btn more"
              onClick={() => {
                setShowMoreTags(true);
              }}
            >
              +{visitTags.length - 4} More
            </button>
          )}
        </div>

        <div className="visit-images-container">
          {visibleTags?.map((tag) => {
            return (
              <>
                <div className="visit-tag-group" key={tag.id}>
                  <div className="visit-tag-group-title">
                    <div className="visit-tag-name d-flex align-items-center">
                      <span className="tag-line"></span>
                      <span>{tag.name}</span>
                    </div>

                    <button
                      className="visit-download-btn"
                      disabled={isDownloading}
                      onClick={() => handleDownloadTag(tag)}
                    >
                      {isDownloading ? "Processing..." : "Download"}
                    </button>
                  </div>

                  <div className="visit-image-grid">
                    {tag?.images?.map((image, index) => {
                      return (
                        <>
                          <div
                            className="visit-image-wrappe"
                            key={image.id || index}
                          >
                            <div className="visit-image-wrapper">
                              <img
                                src={image?.url}
                                alt={`${tag.name} ${index + 1}`}
                              />
                            </div>

                            <span className="visit-image-label">
                              {index === 0
                                ? "Top View"
                                : index === 1
                                  ? "Side View (0°)"
                                  : "Side View (180°)"}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FarmerTag;
